module.exports = __webpack_public_path__ + "static/media/stop-loss.8b4a10c3.svg";